import Vue from "vue";
import Vuex from "vuex";
import VuexPersistence from "vuex-persist";
import Router from '../router';


Vue.use(Vuex);

const vuexLocal = new VuexPersistence({
	storage: window.localStorage,
	modules: ["auth"]
});

const state = {
	sidebarShow: "responsive",
	sidebarMinimize: false,
};

const mutations = {
	toggleSidebarDesktop(state) {
		const sidebarOpened = [true, "responsive"].includes(state.sidebarShow);
		state.sidebarShow = sidebarOpened ? false : "responsive";
	},
	toggleSidebarMobile(state) {
		const sidebarClosed = [false, "responsive"].includes(state.sidebarShow);
		state.sidebarShow = sidebarClosed ? true : "responsive";
	},
	set(state, [variable, value]) {
		state[variable] = value;
	},
};

export default new Vuex.Store({
	state,
	mutations,
	modules: {
		auth: {
			namespaced: true,
			state: {
				access_token: null,
				token_type: null,
				user: {}
			},
			mutations: {
				establecerUsuario(state, data) {
					state.access_token = data.access_token
					state.token_type = data.token_type
					state.user = data.user
					Router.push('/')
				},
				logOut(state) {
					state.access_token = null;
					state.token_type = null;
					state.user = {}
					Router.push('/login')
				}
			},
			getters: {
				user(state) {
					return state.user
				},
				loggedIn(state) {
					return state.access_token != null ? true : false;
				}
			}
		},
		user: {
			namespaced: true,
			state: {
				access_token: '',
				token_type: ''
			},
			mutations: {
				SET_ACCESS_TOKEN(state, token) {
					state.access_token = token.access_token
					state.token_type = token.token_type
				},
				SET_LOGOUT(state) {
					state.access_token = ''
					state.token_type = ''
				}
			}
		},
		general: {
			namespaced: true,
			state: {
				loading: false
			},
			mutations: {
				showLoading(state, loading) {
					state.loading = loading
				}
			},
		}
	},
	plugins: [vuexLocal.plugin]
});
